/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_AccountInputs */

const th_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีของคุณ`)
};

const en_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account`)
};

const ja_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウント`)
};

const zh_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的账户`)
};

const es_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuenta`)
};

const pt_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua conta`)
};

const id_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun Anda`)
};

const fr_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre compte`)
};

const tl_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang account mo`)
};

const vi_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản của bạn`)
};

const ko_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 계정`)
};

const de_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Konto`)
};

const ru_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш аккаунт`)
};

const tr_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesabınız`)
};

const it_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo account`)
};

const pl_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje konto`)
};

const uk_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш обліковий запис`)
};

const hi_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका खाता`)
};

const ar_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حسابك`)
};

const ms_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun anda`)
};

const bn_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার অ্যাকাউন্ট`)
};

const zh_tw2_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的帳戶`)
};

const zh_hk2_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的帳戶`)
};

const ur_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کا اکاؤنٹ`)
};

const fa_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حساب شما`)
};

const sw_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaunti yako`)
};

const nl_profile_account = /** @type {(inputs: Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw account`)
};

/**
* | output |
* | --- |
* | "Your account" |
*
* @param {Profile_AccountInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const profile_account = /** @type {((inputs?: Profile_AccountInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_AccountInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_profile_account(inputs)
	if (locale === "ja") return ja_profile_account(inputs)
	if (locale === "zh") return zh_profile_account(inputs)
	if (locale === "es") return es_profile_account(inputs)
	if (locale === "pt") return pt_profile_account(inputs)
	if (locale === "id") return id_profile_account(inputs)
	if (locale === "fr") return fr_profile_account(inputs)
	if (locale === "tl") return tl_profile_account(inputs)
	if (locale === "vi") return vi_profile_account(inputs)
	if (locale === "ko") return ko_profile_account(inputs)
	if (locale === "de") return de_profile_account(inputs)
	if (locale === "ru") return ru_profile_account(inputs)
	if (locale === "tr") return tr_profile_account(inputs)
	if (locale === "it") return it_profile_account(inputs)
	if (locale === "pl") return pl_profile_account(inputs)
	if (locale === "uk") return uk_profile_account(inputs)
	if (locale === "hi") return hi_profile_account(inputs)
	if (locale === "ar") return ar_profile_account(inputs)
	if (locale === "ms") return ms_profile_account(inputs)
	if (locale === "bn") return bn_profile_account(inputs)
	if (locale === "zh-TW") return zh_tw2_profile_account(inputs)
	if (locale === "zh-HK") return zh_hk2_profile_account(inputs)
	if (locale === "ur") return ur_profile_account(inputs)
	if (locale === "fa") return fa_profile_account(inputs)
	if (locale === "sw") return sw_profile_account(inputs)
	if (locale === "nl") return nl_profile_account(inputs)
	return en_profile_account(inputs)
});